import { render, staticRenderFns } from "./CardTwoColumn.vue?vue&type=template&id=013e2f56&scoped=true"
import script from "./CardTwoColumn.vue?vue&type=script&lang=js"
export * from "./CardTwoColumn.vue?vue&type=script&lang=js"
import style0 from "./CardTwoColumn.vue?vue&type=style&index=0&id=013e2f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e2f56",
  null
  
)

export default component.exports